import ForgotPassword from "@/pages/security/ForgotPassword.tsx";
import Impersonate from "@/pages/security/Impersonate.tsx";
import ImpersonationEnded from "@/pages/security/ImpersonationEnded.tsx";
import Invite from "@/pages/security/Invite.tsx";
import Login from "@/pages/security/Login.tsx";
import ResetPassword from "@/pages/security/ResetPassword.tsx";
import { TwoFactorSetupPage } from "@/pages/security/TwoFactorSetupPage.tsx";
import { dataProtectionRoutes } from "@/routes/configs/modules/data-protection.routes.tsx";
import { offersRoutes } from "@/routes/configs/modules/offers.routes.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ChangePasswordSource } from "@/types/employees/employee.types.ts";

export const anonymousRoutes: RouteConfig[] = [
  { path: "/impersonate", element: <Impersonate /> },
  { path: "/impersonation-ended", element: <ImpersonationEnded /> },
  { path: "/login", element: <Login /> },
  { path: "/login/callback/google", element: <Login /> },
  { path: "/login/callback/entra", element: <Login /> },
  { path: "/login/callback/oidc", element: <Login /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password/:token", element: <ResetPassword /> },
  { path: "/invite/:token", element: <Invite source={ChangePasswordSource.inviteEmail} /> },
  { path: "/invite-link/:token", element: <Invite source={ChangePasswordSource.inviteLink} /> },
  { path: "/tfa-setup/:token", element: <TwoFactorSetupPage /> },
  ...dataProtectionRoutes,
  ...offersRoutes,
];
